import { httpApi } from '@api/http.api';

export interface ClientInfoContact {
    name: string;
    email: string;
    phone: string;
}

export interface CreateClientInfoRequest {
    name: string;
    clientRepresentative: ClientInfoContact;
    blueByteRepresentative: ClientInfoContact;
}

export interface ClientInfo {
    id: number;
    name: string;
    clientRepresentative: ClientInfoContact;
    blueByteRepresentative: ClientInfoContact;
}

export interface CreateClientInfoResponse extends ClientInfo {
    //TODO: update with real types when clientTenants will be created
    clientTenants: any[];
}

// Reuse the same shape for update
export type UpdateClientInfoRequest = CreateClientInfoRequest;

export const createApiClientInfo = (payload: CreateClientInfoRequest): Promise<CreateClientInfoResponse> =>
    httpApi.post<CreateClientInfoResponse>('admin-center/clients', payload).then(({ data }) => data);

// we use raw client info, because clientTenants are not stored yet and admin not finished creating the whole path
export const getApiClientInfo = (clientId: number | string): Promise<ClientInfo> =>
    httpApi.get<ClientInfo>(`admin-center/clients/${clientId}`).then(({ data }) => data);

export const updateApiClientInfo = (clientId: number | string, payload: UpdateClientInfoRequest): Promise<ClientInfo> =>
    httpApi.put<ClientInfo>(`admin-center/clients/${clientId}`, payload).then(({ data }) => data);
